<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>{{ $t('addNew') }} {{ $t('brand.brand') }}</h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader center-block"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <BrandsForm
                            v-show="isLoaded"
                            @loaded="isLoaded = true"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BrandsForm from '@/components/brands/BrandsForm.vue';

export default {
    components: {
        BrandsForm,
    },
    data() {
        return {
            isLoaded: false,
        };
    },
    computed: {
        headTitle() {
            return `${this.$t('addNew')} ${this.$t('brand.brand')}`;
        },
    },
};
</script>
